import html2canvas from "@/lib/html2canvas";
// import jsPDF from "jspdf";
import jsPDF from "@/lib/jsPdf";

interface IProps {
  componentRef: any;
  fileName?: string;
  setLoading: (key: boolean) => void;
  setNoneAfterDownload?: boolean;
}

export const downloadAsImage = ({
  componentRef,
  fileName = "shahrzad",
  setLoading,
  setNoneAfterDownload = true,
}: IProps) => {
  return new Promise((resolve, reject) => {
    if (componentRef.current) {
      setLoading(true);
      const parentElement = componentRef.current.parentElement;
      parentElement.style.display = "block"; // Displaying the component temporarily for rendering
      const scale = window.devicePixelRatio > 1 ? 12 : 6;
      html2canvas.then(instance=>{
        instance(componentRef.current, {
          scale: scale, // Increase scale for higher quality
        })
          .then((canvas) => {
            if (setNoneAfterDownload) {
              parentElement.style.display = "none";
            }
            const image = canvas.toDataURL("image/jpeg");
            const link = document.createElement("a");
            link.href = image;
            link.download = fileName + ".jpeg";
            link.click();
            setLoading(false);
            resolve("done");
          })
          .catch((error) => {
            console.error("An error occurred:", error);
            setLoading(false);
            reject(error);
          });
      })
    } else {
      reject(new Error("Component reference is not available"));
    }
  });
};

export const downloadAsPdf = ({
  componentRef,
  fileName,
  setLoading,
  setNoneAfterDownload = true,
}: IProps) => {
  return new Promise((resolve, reject) => {
    if (componentRef.current) {
      const componentClone = componentRef.current;
      setLoading(true);
      const parentElement = componentRef.current.parentElement;
      parentElement.style.display = "block"; // Displaying the component temporarily for rendering
      const scale = window.devicePixelRatio > 1 ? 12 : 6;
      html2canvas.then(instance=>{
        instance(componentClone, { scale }) // Adjust scale as needed
        .then(async(canvas) => {
          if (setNoneAfterDownload) {
            parentElement.style.display = "none"; // Hide the component again
          }

          // Create a new jsPDF instance with 'p' for portrait or 'l' for landscape orientation
          const jsPdfInstance = await jsPDF;
          const pdf = new jsPdfInstance("p", "pt", [canvas.width, canvas.height]);

          // Calculate the height to maintain aspect ratio
          const imgHeight =
            (canvas.height * pdf.internal.pageSize.getWidth()) / canvas.width;

          // Add the image of the canvas to the PDF
          pdf.addImage(
            canvas.toDataURL("image/jpeg"),
            "JPEG",
            0,
            0,
            pdf.internal.pageSize.getWidth(),
            imgHeight
          );

          // Save the PDF
          pdf.save(fileName + ".pdf");

          setLoading(false);
          resolve("done");
        })
        .catch((error) => {
          console.error("An error occurred:", error);
          setLoading(false);
          reject(error);
        });
      });
      
    } else {
      reject(new Error("Component reference is not available"));
    }
  });
};
